import { render, staticRenderFns } from "./QueueDashboard.vue?vue&type=template&id=6b034a22"
import script from "./QueueDashboard.vue?vue&type=script&lang=js"
export * from "./QueueDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports